import './button.css';

const Button = ({ isChecked, className, message}) => {

    return (
        <div className="button">
            <button
                id='myButon'
                disabled={!isChecked}
                className={className}
                type='submit'
            >
                 {message}

            </button>
        </div>
    );
}

export default Button;